import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyMaterialModule } from 'src/app/app.material';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslocoModule } from '@ngneat/transloco';
import { PdfInspectorErrorModalComponent } from './pdf-inspector-error-modal.component';

@NgModule({
  imports: [
    CommonModule,
    MyMaterialModule,
    MatDialogModule,
    TranslocoModule
  ],
  declarations: [
    PdfInspectorErrorModalComponent
  ],
  exports: [PdfInspectorErrorModalComponent]
})
export class PdfInspectorErrorModalModule { }
